
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.949 12.187l-1.361-1.361-9.504-9.505-.002-.001-.77-.771A1.867 1.867 0 0037.985 0H8.963C7.776 0 6.5.916 6.5 2.926V56c0 .837.841 1.652 1.836 1.909.051.014.1.033.152.043.156.031.315.048.475.048h40.074c.16 0 .319-.017.475-.048.052-.01.101-.029.152-.043.995-.257 1.836-1.072 1.836-1.909V13.978c0-.767-.093-1.334-.551-1.791zM39.5 3.565L47.935 12H39.5V3.565zM8.963 56c-.071 0-.135-.025-.198-.049a.46.46 0 01-.265-.414V41h41v14.537a.46.46 0 01-.265.414c-.063.024-.127.049-.198.049H8.963zM8.5 39V2.926c0-.217.033-.926.463-.926h28.595a1.54 1.54 0 00-.058.391V14h11.608c.135 0 .265-.025.391-.058l.001.036V39h-41z"}}),_c('path',{attrs:{"d":"M15.197 45.045h3.008V54h1.654v-8.955h3.008v-1.121h-7.67zM30.291 43.924l-1.928 4.101h-.136l-1.778-4.101h-1.873l2.721 5.181L24.74 54h1.901l1.722-3.801h.137L30.1 54H32l-2.557-4.895 2.721-5.181zM33.859 45.045h3.008V54h1.654v-8.955h3.008v-1.121h-7.67zM13.5 14h6a1 1 0 100-2h-6a1 1 0 100 2zM13.5 19h9a1 1 0 100-2h-9a1 1 0 100 2zM26.5 19c.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.37-.37-1.05-.37-1.41 0a1 1 0 00-.01 1.42c.189.18.45.29.71.29zM30.5 19h8a1 1 0 100-2h-8a1 1 0 100 2zM12.79 32.29c-.181.19-.29.45-.29.71 0 .26.109.52.29.71.189.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.7-.37-.38-1.05-.38-1.42-.01zM25.5 32h-8a1 1 0 100 2h8a1 1 0 100-2zM44.5 17h-2a1 1 0 100 2h2a1 1 0 100-2zM13.5 24h22a1 1 0 100-2h-22a1 1 0 100 2zM44.5 22h-6a1 1 0 100 2h6a1 1 0 100-2zM13.5 29h4a1 1 0 100-2h-4a1 1 0 100 2zM31.5 27h-10a1 1 0 100 2h10a1 1 0 100-2zM44.5 27h-9a1 1 0 100 2h9a1 1 0 100-2z"}})])
          )
        }
      }
    